import { FC, useState, useEffect } from "react";
import { Select } from "antd";
import { IExamStatsByQuestion } from "../../../models/statistics.model";
import ExamQuestionTable from "../ExamQuestionTable";
import SelectExamSubject from "../SelectExamSubject";
import { useTranslation } from 'react-i18next';
import useAxios from "../../../hooks/useAxios";
import { IExam, IGetExams } from "../../../models/testCenter.model";
import { getExams } from "../../../api/testCenter.api";
import ErrorResponse from "../../ErrorResponse";
import Loader from "../../Loader";

interface IProps {
  data: IExamStatsByQuestion[]|undefined;
  examCode: number|undefined;
  examTypeCode: number|undefined;
  examSubjectCode: number|undefined;
  eduStepCode: String|undefined;
  setExamSubjectCode: (examSubjectCode: number | undefined) => void;
  setExamCode: (examCode: number | undefined) => void;
}

const PtStatsByQuestion: FC<IProps> = ({
  data,
  examCode,
  examTypeCode,
  examSubjectCode,
  eduStepCode,
  setExamSubjectCode,
  setExamCode,
}) => {
  const { t } = useTranslation();
  const { data: res, isLoading, error, execute } = useAxios<IGetExams>();
  const [examDatas, setExamDatas] = useState<IExam[]>();
  const [tempExamCode, setTempExamCode] = useState<number>();

  useEffect(() => {
    doGetExams();
    if(!examTypeCode) {
      setExamCode(undefined);
    }
  }, [examTypeCode]);

  useEffect(() => {
    setTempExamCode(examCode);
  }, [examCode]);

  const doGetExams = (_params?: any) => {
    const parameters = _params || {examTypeCode, eduStepCode, pageNo: 1, perPage: 10 };
    execute(getExams({ ...parameters, examDiv: ['PT'] }));
  }

  useEffect(() => {
    if(res) {
      //시험 openYN이 'Y'인값을 위로 정렬
      const result : IExam[] = res?.data.sort((a,b) => {
        let x = a.openYn;
        let y = b.openYn;
        if(x < y) {
          return 1;
        }
        if(x > y) {
          return -1;
        }
        return 0;
      });
      
      //시험유형이 없는 경우('전체') 시험코드 초기화
      if(result.length > 0 && examTypeCode) {
        setExamCode(result[0].examCode);
      } else {
        setExamCode(undefined);
      }

      setExamDatas(result);
    }
  }, [res, isLoading])

  return (
    <>
      {isLoading && <Loader />}
      <ErrorResponse error={error} />

      <div className="flex flex-justify-end comm-bx__space comm-gap">
        <div className="w-210p">
          <Select
            className="w-210p"
            placeholder={t('class.class.column3')}
            value={(examTypeCode) ? tempExamCode : undefined}
            onChange={(value)=>{
              setExamCode(value);
              setTempExamCode(value);
            }}
            disabled
          >
            {(examTypeCode) && examDatas?.map(item => {
              //if(item.openYn === 'Y') { openYn조건을 걸 경우 초,중등 기존 조회 가능했던 이전 시험지 값을 조회할 수 없음
                return (
                <Select.Option
                  key={item.examCode}
                  value={item.examCode}
                >
                {item.examName}
                </Select.Option>
                )
              //}
            })}
          </Select>
        </div>
        <div className="w-150p">
          <SelectExamSubject
            examCode={examCode}
            examSubjectCode={examSubjectCode}
            setExamSubjectCode={setExamSubjectCode}
          />
        </div>
      </div>
      <ExamQuestionTable data={data} />
    </>
  );
}

export default PtStatsByQuestion;
